<template>
  <summary-count
    title="Awaiting Onboarding"
    :is-loading="isLoading"
    :count="count"
    :count-class="'tw-text-yellow-600'"
    :caption="'New Prescriptions'"
    :caption-class="'tw-text-yellow-600'"
    :clickable="true"
    @cardClicked="gotoPrescriptions"
  />
</template>

<script>
import SummaryCount from "@/views/business/dashboard/components/SummaryCount.vue";

export default {
  name: "AwaitingOnboarding",
  components: {
    SummaryCount,
  },
  props: {
    summaryData: {
      type: Object,
      default: () => ({}),
    },
    isSummaryLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    count() {
      return this.summaryData.awaitingOnboarding || 0;
    },
    isLoading() {
      return this.isSummaryLoading;
    },
  },
  methods: {
    gotoPrescriptions() {
      this.$router.push({
        path: `/businesses/${this.$route.params.businessId}/prescriptions`,
        query: { status: "new" },
      });
    },
  },
};
</script>
